// Auto generated file, do not manually modify!
// com.hotpads.adproducts.client.boost.enums.ClientCpmBoostType

export enum ClientCpmBoostType {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  INSTAGRAM_STORY = 'INSTAGRAM_STORY',
  TIKTOK = 'TIKTOK',
  ZG = 'ZG',
}

export const ClientCpmBoostType_values = [
  ClientCpmBoostType.FACEBOOK,
  ClientCpmBoostType.INSTAGRAM,
  ClientCpmBoostType.INSTAGRAM_STORY,
  ClientCpmBoostType.TIKTOK,
  ClientCpmBoostType.ZG,
] as const;
